import React from "react";
import { countryName } from "@/lib/countries";

export function Flag({ code, className = "", size = 20 }) {
  if (!code || code.length !== 2) return null;
  const c = code.toLowerCase();
  const h = Math.round((size * 3) / 4);
  return (
    <img
      src={`https://flagcdn.com/${size * 2}x${h * 2}/${c}.png`}
      width={size}
      height={h}
      alt={countryName(code)}
      title={countryName(code)}
      loading="lazy"
      className={`inline-block rounded-[2px] object-cover ${className}`}
    />
  );
}
